import enJSON from '@/common/utilities/lang/en/homeOwner.js';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import esJSON from '@/common/utilities/lang/es/homeOwner.js';
import ownerContent from '@/home-owner/components/ownercontent/owner-content.vue';
import ownerWelcome from '@/home-owner/components/ownerwelcome/owner-welcome.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageHomeOwner',
    inject: ['$eventBus'],
    data() {
        return {
            showDashBoard: false,
            tempClaimedHomes: null,
        };
    },
    components: {
        mvtPopSignin,
        mvtHeader,
        mvtDialogCenter,
        ownerWelcome,
        ownerContent,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'homeOwner', en: enJSON, es: esJSON });
    },
    methods: {
        hasRedirectedLogin: function () {
            const qs = this.$route.query;
            if (qs && qs.showlogin) {
                const redirectUrl = qs.returnurl;
                if (this.glb.user.id) {
                    redirectUrl && (location.href = redirectUrl);
                } else {
                    this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin', redirectUrl }, trigger: this.$options.name });
                }
            }
        },
    },
    mounted() {
        this.hasRedirectedLogin();
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
